import { buildOverrides as mapBuildOverrides } from '@map/theme/components';
import { MobileTheme } from '@map/theme/types';
import { Theme } from '@mui/material/styles';

export const buildOverrides = (theme: MobileTheme) => {
  const { palette } = theme;
  const overrides: Theme['components'] = {
    ...mapBuildOverrides(theme),
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: 'transparent',
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          width: '100%',
          overflow: 'hidden auto',
        },
        html: {
          display: 'flex',
          minHeight: '100%',
          overscrollBehaviorY: 'none',
          backgroundColor: palette.neutrals[200],
        },
      },
    },
  };
  return overrides;
};
